export class attachment {
  fileName: string;
  fileUrl: string;
}
